export class LayoutEnvironment {
  public static getName = () => 'benzinga-layout';
  public static getEnvironment = (env: Record<string, string>) => ({
    maxLayoutVersion: env.maxLayoutVersion,
    url: new URL(env.url ?? 'https://accounts.benzinga.com/'),
  });
}
